<script setup lang="ts">
import { ref, computed, watch, onMounted, onUpdated} from "vue";
const selectedValue = ref("");
const selectedObject = ref(null);
const props = defineProps({
  defaultValue: {
    type: Object,
    required: false,
  },
  datas: {
    type: Array<Object>,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  specifLabel: {
    type : Array<String>,
    required: false,
  },
  specifSearch: {
    type : Array<String>,
    required: false,
  },
  label: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
  displayIcon: {
    type: Boolean,
    required: false,
    default: false,
  },
  icon: {
    type: String,
    required: false,
  },
  displayPrefix: {
    type: Boolean,
    required: false,
    default: false,
  },
  prefix: {
    type: String,
    required: false,
  },
  size: {
    type: String,
    required: false,
    default: "default",
  },
  filterable: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  placeholder: {
    type: String,
    required: false,
    default: ' ',
  },
  focusable: {
    type: Boolean,
    required: false,
    default: true,
  },
  clearable: {
    type: Boolean,
    required: false,
    default: false
  }
});

const emit = defineEmits(["selectedValue"]);
const URLPage = import.meta.url

const updateSelectedValue = (value:any) => {
  emit("selectedValue", selectedValue.value);
  selectedObject.value = props.datas.find(
    (item) => item[props.value] === value,
  );

};

let listData = [] as Object[];
const optionFilter = ref([] as Object[])

onMounted(() => {

  listData = props.datas
  optionFilter.value = props.datas

  if(props.defaultValue){
    selectedValue.value = props.defaultValue[props.value];
    updateSelectedValue(selectedValue.value);
  }
});

onUpdated(() => {

  listData = props.datas
  optionFilter.value = props.datas

  if( props.defaultValue && !selectedValue.value){
    selectedValue.value = props.defaultValue[props.value];
    updateSelectedValue();
  } 

});

watch(() => props.defaultValue, (valueSet) => {

    if(props.defaultValue && props.defaultValue[props.value] != selectedValue.value) {
      selectedValue.value = props.defaultValue[props.value];
      updateSelectedValue();
    } 

  }
);

const tabNumber = computed(() => (props.focusable ? "" : "-1"));

function normalizeString(str : String) {
  return str.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const getImageUrl = (path:any) => {
  return new URL(`/${path}`, URLPage).href
}

const labelValueSpecific =  computed(() => {

  var specificLabel = false
  
  for(const lblSpecif in props.specifLabel) {
    specificLabel = true
  }

  return specificLabel
})

const getSpecificLabel = (item:any, listSpecificLabel:any) => {

  var specifLabel = ""

  for (let index = 0; index < listSpecificLabel.length; index++) {
    const label = listSpecificLabel[index];
    
    if(label.includes(".")) {

      var splitArray = label.split(".")

      if(item[splitArray[0]]) {
        specifLabel += item[splitArray[0]][splitArray[1]] + ((index + 1) < listSpecificLabel.length ? ' - ' : '')
      }
    }else{
      if(item[label]) {
        specifLabel += item[label] + ((index + 1) < listSpecificLabel.length ? ' - ' : '')
      }
    }
  }

  return specifLabel
}

const filterOption = (query : string) => {

  optionFilter.value = listData.filter(item => {
    
    if(props.specifSearch?.length && props.specifSearch.length > 0) {

      var boolSearch = false

      for (let index = 0; index < props.specifSearch.length; index++) {
        const element = props.specifSearch[index];
        
        if(item[element] != undefined && item[element] != null) {

          boolSearch = normalizeString(String(item[element]))
          .includes(normalizeString(query))

          if (boolSearch) {
            return true
          }

        }

      }

      return boolSearch
     
    } else {
      const displaySelect = !labelValueSpecific ? item[props.label] : (props.label?.includes('.') ? ( item[props.label?.split('.')[0]] != undefined && item[props.label?.split('.')[0]] != null ? item[props.label?.split('.')[0]][props.label?.split('.')[1]] : item[props.value]) : item[props.label])

      return normalizeString(String(item[props.value]))
        .includes(normalizeString(query)) || 
        normalizeString(String(displaySelect))
        .includes(normalizeString(query));   
    }
  }        
  );

}

const getRandomClass = () => {
  const classes = ['item-orange', 'item-rien', 'item-blue', 'item-purple'];

  if(false) {
    return classes[Math.floor(Math.random() * classes.length)];
  } else {
    return '';
  }

};

</script>

<template>

  <el-select
    v-model="selectedValue"
    :disabled="props.disabled"
    :filterable="props.filterable"
    :filter-method="filterOption"
    :size="props.size"
    @update:model-value="updateSelectedValue"
    :placeholder="props.placeholder"
    :clearable="props.clearable"
    :class="props.clearable && selectedValue ? 'wrapper_clear_hover' : 'wrapper_classic_hover'"
  >
    <template #prefix v-if="props.displayPrefix">
      <slot name="prefix">
        <img
          class="prefix"
          v-if="selectedObject"
          :src="
            selectedObject[props.prefix] != undefined
              ? getImageUrl(selectedObject[props.prefix])
              : ''
          "
        />
      </slot>
    </template>
    
    <!-- item[props.label.split('.')[0]][props.label.split('.')[1]] -->

    <el-option
      v-for="item in optionFilter"
      :key="item[props.id]"
      :label="!labelValueSpecific ? item[props.label] : (props.label?.includes('.') ? ( item[props.label?.split('.')[0]] != undefined && item[props.label?.split('.')[0]] != null ? item[props.label?.split('.')[0]][props.label?.split('.')[1]] : item[props.value]) : item[props.label])"
      :value="item[props.value]"
      :class="getRandomClass()"
    >
      <div>
        <img
          v-if="props.displayIcon && item[props.icon]"
          :src="getImageUrl(item[props.icon])"
          :alt="item[props.icon]"
        />
        <span v-if="!labelValueSpecific">{{ item[props.label] }}</span>
        <span v-else>
           {{ getSpecificLabel(item, props.specifLabel) }}
        </span>
      </div>
    </el-option>
  </el-select>
</template>

<style lang="scss">
@use "../../assets/css/utils/_variables.scss" as *;
.el-select-dropdown {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  &__item {
    &:hover {
      background-color: $blue !important;
      color: $white !important;

      &.selected {
        color: #f1c40f !important;
      }

      img {
        filter: brightness(0) invert(1);
      }
    }
  }
  span {
    margin-left: 1.5vh;
    margin-right: 1.5vh;
  }
}
.el-input__inner {
  color: $black;
  font-size: 1em;
  margin-left: 1.5vh;
  margin-right: 1.5vh;
  &::placeholder {
    color: $black;
    font-size: 1em;
    margin-right: 1.5vh;
  }
}

.wrapper_classic_hover {
  .el-input__wrapper:hover {
    background-color: $blue;
    color: $white;

    .el-select__caret::before {
      filter: brightness(0) invert(1);
    }
    .prefix {
      filter: brightness(0) invert(1);
    }
    .el-input__inner::placeholder {
      color: $white;
    }
    .el-input__inner {
      color: $white;
    }
  }
}

.wrapper_clear_hover {
  .el-input__wrapper:hover {
    background-color: $blue;
    color: $white;

    .el-select__caret::before {
      content: url("src/assets/images/cross-red.svg");
    }
    .prefix {
      filter: brightness(0) invert(1);
    }
    .el-input__inner::placeholder {
      color: $white;
    }
    .el-input__inner {
      color: $white;
    }
  }
}

.el-select-dropdown__item.selected {
  color: $blue !important;
  &:hover {
    color: $white;
  }
}

.el-input.el-input--suffix {
  height: 3.4vh;
  width: 100%;
}

.el-select {
  border-radius: 4px;
}

.el-select__caret::before {
  content: url("/src/assets/images/chevron.svg");
}

.el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    color: #b0a6ff !important;
    font-weight: bold;
}

.item-orange {
  background-color: #e8b931 !important;
  color: black !important;
}

.item-blue {
  background-color: #6DD0DB !important;
  color: white !important;
}

.item-purple {
  background-color: #B97ED0 !important;
  color: white !important;
}

</style>
